import { logger } from './logger';

interface PlaceholderPopupOptions {
  title: string;
  heading: string;
  message: string;
}

const ensureDocumentShell = (popupDocument: Document) => {
  const head = popupDocument.head ?? popupDocument.createElement('head');
  const body = popupDocument.body ?? popupDocument.createElement('body');

  if (!popupDocument.head) {
    popupDocument.documentElement.appendChild(head);
  }

  if (!popupDocument.body) {
    popupDocument.documentElement.appendChild(body);
  }

  return { head, body };
};

export const openPlaceholderPopup = ({
  title,
  heading,
  message,
}: PlaceholderPopupOptions): Window | null => {
  const popup = window.open('', '_blank');
  if (!popup) {
    return null;
  }

  try {
    popup.opener = null;
  } catch (error) {
    logger.warn('Failed to clear popup opener:', error);
  }

  try {
    const { head, body } = ensureDocumentShell(popup.document);

    head.textContent = '';
    body.textContent = '';

    popup.document.title = title;

    const meta = popup.document.createElement('meta');
    meta.setAttribute('charset', 'utf-8');

    const style = popup.document.createElement('style');
    style.textContent =
      'body{font-family:-apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;padding:24px;line-height:1.6}';

    const headingElement = popup.document.createElement('h3');
    headingElement.textContent = heading;

    const messageElement = popup.document.createElement('p');
    messageElement.textContent = message;

    head.append(meta, style);
    body.append(headingElement, messageElement);
  } catch (error) {
    logger.error('Failed to initialize placeholder popup:', error);
  }

  return popup;
};
